import React from 'react';
import PropTypes from 'prop-types';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider, StylesProvider } from '@material-ui/styles';
import { ProximaNovaRegular, ProximaNovaBold, Aquatico } from './fonts';

import {
    overrides as buttonOverrides,
    props as buttonProps
} from '../button/styles';
import { props as textfieldProps } from '../textfield/styles';
import { overrides as dialogOverrides } from '../dialog/styles';
import { overrides as radioOverrides } from '../radio/styles';
import { overrides as checkboxOverrides } from '../checkbox/styles';
import { overrides as inputLabelOverrides } from '../input-label/styles';
import { overrides as formLabelOverrides } from '../form-label/styles';
import { overrides as typographyOverrides } from '../typography/styles';
import { overrides as tooltipOverrides } from '../tooltip/styles';
import { overrides as toggleButtonOverrides } from '../toggle-button/styles';
import { overrides as chipOverrides } from '../chip/styles';
import { overrides as alertTitleOverrides } from '../alert-title/styles';
import { overrides as tableOverrides } from '../table/styles';

const overrides = {
    MuiCssBaseline: {
        '@global': {
            body: {
                minHeight: '100vh'
            },
            '@font-face': [ProximaNovaRegular, ProximaNovaBold, Aquatico]
        }
    },
    ...buttonOverrides,
    ...dialogOverrides,
    ...radioOverrides,
    ...checkboxOverrides,
    ...inputLabelOverrides,
    ...formLabelOverrides,
    ...typographyOverrides,
    ...tooltipOverrides,
    ...toggleButtonOverrides,
    ...chipOverrides,
    ...alertTitleOverrides,
    ...tableOverrides
};

const props = {
    ...buttonProps,
    ...textfieldProps
};

const typography = {
    fontFamily: '"Proxima Nova", "Helvetica Neue", sans-serif',
    h1: {
        fontFamily: 'Aquatico, "Helvetica Neue", sans-serif',
        fontSize: '1.8em'
    },
    h2: {
        fontFamily: 'Aquatico, "Helvetica Neue", sans-serif',
        fontSize: '1.6em',
        fontWeight: 'normal'
    },
    p: {
        fontFamily: 'Helvetica, "Helvetica Neue", sans-serif'
    }
};

const spacing = 5;

export const structuralTheme = {
    spacing,
    typography,
    overrides,
    props
};

export default function Theme({ children, theme }) {
    return (
        <StylesProvider injectFirst>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </StylesProvider>
    );
}

Theme.propTypes = {
    children: PropTypes.node.isRequired,
    theme: PropTypes.shape({}).isRequired
};
